import React from 'react';
import {CustomerStore} from './customer.store';
import {UserStore} from './user.store';
import {FwVersionStore} from './fw-version.store';
import {UserPreferencesStore} from './user-preferences.store';
import {ReportsStore} from './reports.store';
import {LogsStore} from './logs.store';
import {NotificationStore} from './notifications.store';
import {DashboardStore} from './dashboard.store';
import {UnsavedChangesStore} from './unsaved-changes.store';
import {ActivityStore} from './activity.store';
import {BaseStore} from './base.store';
import {UIStore} from './ui.store';
import {RuleStore} from './rule.store';
import {FwVersionBronzeStore} from './fw-version-bronze.store';
import {DevicesStore} from './devices.store';

export class RootStore {

  public dashboardStore: DashboardStore;
  public customerStore: CustomerStore;
  public userStore: UserStore;
  public fwVersionStore: FwVersionStore;
  public fwVersionBronzeStore: FwVersionBronzeStore;
  public userPreferencesStore: UserPreferencesStore;
  public reportsStore: ReportsStore;
  public logsStore: LogsStore;
  public notificationStore: NotificationStore;
  public unsavedChangesStore: UnsavedChangesStore;
  public activityStore: ActivityStore;
  public uiStore: UIStore;
  public ruleStore: RuleStore;
  public devicesStore: DevicesStore;

  constructor() {
    this.dashboardStore = new DashboardStore(this);
    this.customerStore = new CustomerStore(this);
    this.userStore = new UserStore(this);
    this.fwVersionStore = new FwVersionStore(this);
    this.fwVersionBronzeStore = new FwVersionBronzeStore(this);
    this.userPreferencesStore = new UserPreferencesStore(this);
    this.reportsStore = new ReportsStore(this);
    this.logsStore = new LogsStore(this);
    this.notificationStore = new NotificationStore(this);
    this.unsavedChangesStore = new UnsavedChangesStore(this);
    this.activityStore = new ActivityStore(this);
    this.uiStore = new UIStore(this);
    this.ruleStore = new RuleStore(this);
    this.devicesStore = new DevicesStore(this);
  }

  reset() {
    const resetStore: BaseStore[] = [this.fwVersionStore, this.userPreferencesStore, this.reportsStore, this.dashboardStore, this.activityStore, this.logsStore, this.devicesStore];
    resetStore.forEach(store => store.reset());
  }
}

export const StoresContext = React.createContext(new RootStore());

export const useStores = () => React.useContext(StoresContext);